import {StyleProps} from '../../ui'
import {useChartMeta} from './chartMeta'
import {ChartCfg} from './chartMeta.types'

export const ChartView = ({cfg, className}: {cfg?: ChartCfg} & StyleProps) => {
  const meta = useChartMeta(cfg?.type)
  const {
    View,
    edit: {cfgToProps}
  } = meta
  return cfg ? <View chart={cfgToProps(cfg)} className={className} /> : <></>
}

export default ChartView
